import { isApolloError } from '@apollo/client';

type OperationErrorDetail = {
  codeAsString?: string;
  message?: string;
};

type OperationError = {
  code?: number;
  details?: OperationErrorDetail[];
  message?: string;
};

type NonErrorMessage = {
  message?: string;
};

const isOperationError = (error: unknown): error is OperationError =>
  !!(error as OperationError).details;

const isNonErrorMessage = (error: unknown): error is NonErrorMessage =>
  !!(error as NonErrorMessage).message;

export const resolveGqlErrors = (error?: unknown | Error): string => {
  if (!error) {
    return '';
  }

  if (isOperationError(error)) {
    const [detailError] = error.details ?? [];
    return detailError?.message ?? error.message ?? '';
  }

  if (error instanceof Error && isApolloError(error)) {
    return error.message;
  }

  if (isNonErrorMessage(error)) {
    return error.message ?? '';
  }

  return '';
};
